import gql from 'graphql-tag';

const mutation = gql`
  mutation AuthenticatedPasswordChange($params: AuthenticatedPasswordChangeParams!) {
    authenticatedPasswordChange(params: $params)
  }
`;

export default mutation;
